/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/465-stackoverflow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 10v6H0v-6h2v4h12v-4zM3 11h10v2H3zm.237-2.165l.433-1.953 9.763 2.164L13 10.999zM4.37 4.821l.845-1.813 9.063 4.226-.845 1.813zm11.126.827l-1.218 1.587-7.934-6.088L7.224 0h.91z"/>'
  }
})
